import React from 'react'
import ViewInThreeDIcon from '../MediaGallery/icons/ViewInThreeDIcon'
import ViewInYourRoomIcon from '../MediaGallery/icons/ViewInYourRoomIcon'
import { pushEventAndTrack } from '../../helpers/taggingSerializer'
import * as Styled from './AR3DButton.styles'

const AR3DButton = ({
  only3DViewer = true,
  onClick = () => null,
  href = null,
  rel = 'ar',
  'data-test': dataTest,
  thumbnail = false,
  isFullSize
}) => {
  const clickTrack = () => {
    pushEventAndTrack({
      eventInfo: {
        eventName: 'pdp_ar3d_Interaction',
        eventAction: 'pdp AR3D Interaction'
      }
    })
    onClick?.()
  }

  if (href) {
    return (
      <Styled.Container thumbnail={thumbnail} iosAR data-test='ar-button-container'>
        <a onClick={() => clickTrack()} href={href} rel={rel} data-test={`${dataTest}-link`}>
          <img alt='3D cube badge' src='//documents.4rgos.it/v1/static/ar-icon' />
          <Styled.IosText thumbnail={thumbnail}>View in your room</Styled.IosText>
        </a>
      </Styled.Container>
    )
  }

  if (!href && !only3DViewer) {
    return (
      <Styled.Container thumbnail={thumbnail} data-test='ar-button-container'>
        <button onClick={() => clickTrack()} data-test={`${dataTest}-button`} type='button'>
          <ViewInYourRoomIcon />
        </button>
      </Styled.Container>
    )
  }

  return (
    <Styled.Container thumbnail={thumbnail} data-test='ar-button-container' isFullSize={isFullSize}>
      <button onClick={() => clickTrack()} data-test={`${dataTest}-button`} type='button'>
        <ViewInThreeDIcon showLargeIcon={isFullSize} />
      </button>
    </Styled.Container>
  )
}
export default AR3DButton
